// ============================================================
//  StatCard.jsx  – reusable stat summary card with hover tooltip
//  Props:
//    icon        – PrimeIcons class string e.g. "pi pi-building"
//    label       – short label shown below the icon
//    value       – main number/string displayed prominently
//    color       – hex colour for icon background tint
//    tooltip?    – optional string shown on hover
// ============================================================
import React, { useState } from "react";

const StatCard = ({ icon, label, value, color, tooltip }) => {
    const [visible, setVisible] = useState(false);

    return (
        <div
            className="stat-card"
            style={styles.card}
            onMouseEnter={() => setVisible(true)}
            onMouseLeave={() => setVisible(false)}
        >
            {/* Tooltip */}
            {tooltip && visible && (
                <div style={styles.tooltip}>
                    <i
                        className="pi pi-info-circle"
                        style={styles.tooltipIcon}
                    />
                    {tooltip}
                </div>
            )}

            {/* Card content */}
            <div
                className="stat-card__icon"
                style={{ background: `${color}18` }}
            >
                <i className={icon} style={{ color, fontSize: 18 }} />
            </div>
            <div className="stat-card__label">{label}</div>
            <div className="stat-card__value">{value}</div>
        </div>
    );
};

const styles = {
    card: {
        display: "flex",
        flexDirection: "column",
        gap: 4,
        position: "relative",
        transition: "box-shadow 0.15s ease, transform 0.15s ease",
        cursor: "default",
    },

    tooltip: {
        position: "absolute",
        top: 0,
        left: 20,
        background: "#F0FDF4",
        color: "#166534",
        border: "1px solid #BBF7D0",
        borderRadius: 8,
        padding: "9px 13px",
        fontSize: 12,
        fontFamily: "var(--font-sans)",
        fontWeight: 400,
        lineHeight: 1.6,
        whiteSpace: "normal",
        minWidth: 250,
        wordBreak: "break-word",
        boxShadow: "0 4px 12px rgba(76,175,80,0.12)",
        zIndex: 100,
        display: "flex",
        alignItems: "flex-start",
        gap: 6,
        pointerEvents: "none",
    },

    tooltipIcon: {
        fontSize: 12,
        color: "#4CAF50",
        marginTop: 1,
        flexShrink: 0,
    },
};

export default StatCard;
